export default {
  title: 'Permissões',
  description: 'Defina quais funcionalidades cada usuário ou perfil de acesso pode utilizar.',
  labels: {
    new: 'Nova Permissão',
    dataPermission: 'Dados da Permissão',
    modulePermission: 'Módulos',
    users: 'Usuários',
    roles: 'Perfis de Acesso'
  },
  
  form:{
    title: 'Cadastro de Permissões'
  },
  fields: {
    name: 'Nome da Permissão',
  },
  modules:{
    title: 'Seleção de Módulos',
    labels:{
      new: 'Novo Módulo'
    },
    fields:{
      name: 'Módulo',
      level: 'Nível de Acesso',
    }
  },
  listUsers: {
    source: 'Cadastrados',
    catalog: 'Disponíveis',
    target: 'Incluídos',
  },
  listRoles: {
    source: 'Cadastrados',
    catalog: 'Disponíveis',
    target: 'Incluídos',
  },
};
